import { useGroupRole } from '@jbroll/rowboat-sharing-react';
import { usePort } from '@/rowboat';

/**
 * Whether the signed-in user is a Viewer (`reader`) of the project group, whose edits Rowboat
 * refuses. While the role loads and when its request fails, the project stays editable: the
 * request fails offline, and capture must keep working there; a refused push is quarantined,
 * not lost.
 */
export function useReadOnly(groupId: string | null | undefined): boolean {
  const { author } = usePort();
  // Anonymous projects never sync and the root group is the account's own: no role to ask about.
  const state = useGroupRole(author && groupId && groupId !== author ? groupId : null);
  switch (state.status) {
    case 'idle':
    case 'loading':
    case 'error':
      return false;
    case 'ok':
      return state.role === 'reader';
  }
}
